import type {BetterSystemStyleObject} from '@primer/styled-react'
import {Box} from '@primer/styled-react'
import type {TooltipProps} from '@primer/react/deprecated'
import {clsx} from 'clsx'

import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import type {Branch} from '../types'
import BranchProtectionShield from './BranchProtectionShield'
import TruncatedBranchName from './TruncatedBranchName'

import styles from './BranchDescription.module.css'

interface BranchDescriptionProps extends Pick<
  Branch,
  'name' | 'path' | 'rulesetsPath' | 'protectedByBranchProtections'
> {
  className?: string
  isLarge?: boolean
  sx?: BetterSystemStyleObject
}

export default function BranchDescription({className, isLarge = false, sx, ...branch}: BranchDescriptionProps) {
  const direction: TooltipProps['direction'] = !isLarge && branch.name.length < 3 ? 'ne' : undefined
  return (
    <Box
      sx={{
        ...sx,
        height: BranchDescriptionHeight,
      }}
      className={clsx(className, styles.Container)}
    >
      <TruncatedBranchName {...branch} />
      <div className={styles.ActionGroup}>
        <CopyToClipboardButton
          className="d-flex flex-justify-center"
          style={{width: BranchDescriptionHeight}}
          textToCopy={branch.name}
          ariaLabel="Copy branch name to clipboard"
          tooltipProps={{direction}}
        />
        <BranchProtectionShield {...branch} isLarge={isLarge} />
      </div>
    </Box>
  )
}

export const BranchDescriptionHeight = 32

try{ BranchDescription.displayName ||= 'BranchDescription' } catch {}